import { render, staticRenderFns } from "./ProfileUnlockTable.vue?vue&type=template&id=056742a5"
import script from "./ProfileUnlockTable.vue?vue&type=script&lang=js"
export * from "./ProfileUnlockTable.vue?vue&type=script&lang=js"
import style0 from "./ProfileUnlockTable.vue?vue&type=style&index=0&id=056742a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports